<style lang="scss" scoped>
  @import "../../../../assets/scss/mixins";

  $leftWidth: 220px;

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .content-part {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: $leftWidth;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      text-align: left;
      background-color: #eef2f3;

      > ul {
        margin: 0;
      }

      > h2 {
        padding: 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        border-bottom: 1px solid #ddd;
        background-color: #eef2f3;
      }

      .list-style {
        cursor: pointer;
        padding: 10px;
        text-align: center;

        span {
          display: inline-block;
          padding: 8px 35px;
        }

        &.active {
          span {
            background-color: $activeColor;
            border-radius: 20px;
            color: $activeColorFont
          }
        }

        &:hover {
          background: #dee9eb
        }

      }

    }

    .content-right {
      > h3 {
        padding: 0;
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: normal;
        line-height: 55px;
        height: 55px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        left: $leftWidth;
        background: #fff;
        z-index: 2;
      }

      position: absolute;
      top: 0;
      left: $leftWidth;
      right: 0;
      bottom: 0;
      overflow: auto;
      /*.hide-content {*/
      /*display: none;*/
      /*}*/
      /*.show-content {*/
      /*display: block;*/
      /*}*/
    }

    .btn-submit-save {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      text-align: center;
      padding: 15px;
    }

    .min-gutter {
      .el-form-item {
        /*margin-bottom: 20px;*/
      }

      .el-form-item__label {
        font-size: 12px
      }
    }

    .qp-box {
      margin-bottom: 5px;
      padding: 4px;
      box-shadow: 0 2px 1px 0 #ddd;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .el-form .el-date-editor {
    display: block;
  }

  .el-form {
    border: 1px solid #eef2f3;
    margin: 15px 10px;
    padding-top: 15px;
    border-radius: 4px;
    position: relative;

    &.active {
      border-color: $activeColor;

      .title-link {
        color: $activeColor;
      }
    }
  }

  .title-link {
    position: absolute;
    top: -10px;
    left: 5px;
    padding: 0;
  }
</style>


<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix right-title">上传Excel</h2>
        <ul>
          <div class="btn-submit-save">
            <div>
              <el-button type="primary" style="width: 180px" @click.prevent.stop="importExcel()"
                         :disabled="doing" :loading="doing">{{title}}
              </el-button>
            </div>
          </div>
        </ul>
      </div>
      <div class="content-right min-gutter">
        <h3>上传Excel批量新增货品</h3>
        <el-form id="form" class="form-part" ref="attachmentForm" label-width="160px"
                 style="padding-right: 20px;margin-top: 80px">
          <h2 class="title-link">附件上传</h2>
          <div class="hide-content">
            <el-form-item label="附件">
              <oms-upload :fileList="attachmentList" @change="changeFiles"></oms-upload>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {Goods} from '../../../../resources'
  import utils from '@/tools/utils';

  export default {
    components: {},
    name: 'importForm',
    props: {
      showtext: Boolean
    },
    data: function () {
      return {
        attachmentList: [],
        attachmentIdList: [],
        index: 0,
        doing: false,
        title: '上传Excel'
      };
    },
    computed: {},
    watch: {
      showtext() {
        this.attachmentList = [];
        this.attachmentIdList = [];
      }
    },
    mounted: function () {
    },
    methods: {
      changeFiles: function (fileList) {
        let ids = [];
        fileList.forEach(file => {
          ids.push(file.attachmentId);
        });
        this.attachmentIdList = ids;
      },
      importExcel: function () {
        if (!this.attachmentIdList || this.attachmentIdList.length === 0) {
          this.$notify.warning({
            duration: 1500,
            name: '警告',
            message: '请上传Excel文件'
          });
          return;
        }
        this.doing = true;
        this.title = '上传解析中...';
        Goods.importExcelToAddplatformGoods(this.attachmentIdList).then(res => {
          if (res.data.path) {
            // 如果有url返回,则下载错误信息的Excel
            this.$store.commit('initPrint', {
              isPrinting: true,
              moduleId: '/product',
              text: '导入的Excel文件中存在错误内容,正在导出内容存在错误的货品信息'
            });
            utils.download(res.data.path, '错误货品表');
            this.$store.commit('initPrint', {
              isPrinting: false,
              moduleId: '/product',
              text: '请将错误内容编辑正确后重新上传'
            });
            this.$notify.warning({
              duration: 2000,
              name: '警告',
              message: '请将错误内容编辑正确后重新上传'
            });
          } else {
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '导入Excel批量新增货品成功'
            });
          }
          this.doing = false;
          this.title = '上传Excel';
          // 清空附件列表
          this.attachmentList = [];
          this.attachmentIdList = [];
          this.$emit('change', res.data);
          this.$emit('right-close');
        }).catch(error => {
          this.$notify.error({
            message: error.response.data && error.response.data.msg || '导入Excel批量新增货品失败'
          });
          this.doing = false;
          this.title = '上传Excel';
        });
      }
    }
  };
</script>
